export enum MediaType {
	Image,
	YouTubeLink,
	InstagramPost,
  Vimeo
}
